import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HomeState } from "../types";
import { initialState } from "./initialState";

export const sliceKey = "homeState";

const homeSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getHomeData(state) {
      state.loading = true;
    },

    getHomeDataSuccess(state, action: PayloadAction<HomeState>) {
      state.loading = false;
      state.statusItems = action.payload.statusItems;
      state.summaryCards = action.payload.summaryCards;
      state.vehicles = action.payload.vehicles;
      state.scheduleExceptions = action.payload.scheduleExceptions;
      state.engineeringAlerts = action.payload.engineeringAlerts;
    },

    getHomeDataFailed(state) {
      state.loading = false;
    },
  },
});

export const { actions, reducer } = homeSlice;